/**
 * What to tell the reviewer after a commit, from the ViewModel's outcome string.
 *
 * Returns null when the outcome already explains itself in the error banner and
 * nothing was written — 'stale' included: the server REJECTED that submit, so a
 * toast would tell the reviewer their work saved when it did not.
 *
 * @param {string} outcome one of the useDocumentReviewViewModel outcome strings
 * @param {string} [fileName] the committed document's name, if known
 * @returns {{message: string, type: string}|null}
 */
export function commitNotice(outcome, fileName) {
  if (outcome === 'incomplete' || outcome === 'invalid'
      || outcome === 'stale' || outcome === 'error') {
    return null;
  }

  if (outcome === 'conflict') {
    return {
      message: `${fileName || 'That document'} was already reviewed by someone else. Moving on.`,
      type: 'info',
    };
  }

  // Not a failure: correcting or skipping a base field can newly flag a field
  // derived from it, so the document legitimately stays parked.
  if (outcome === 'partial') {
    return {
      message: 'Saved. Resolving those fields raised new ones on this document.',
      type: 'info',
    };
  }

  return {
    message: `${fileName || 'Document'} saved — processing resumed.`,
    type: 'success',
  };
}

export default commitNotice;
